import { render, staticRenderFns } from "./compliance-tab.vue?vue&type=template&id=23b51649&scoped=true"
import script from "./compliance-tab.vue?vue&type=script&lang=js"
export * from "./compliance-tab.vue?vue&type=script&lang=js"
import style0 from "./compliance-tab.vue?vue&type=style&index=0&id=23b51649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b51649",
  null
  
)

export default component.exports